import React from "react";
import Modal from "react-modal";
import { useNavigate } from "react-router-dom";

const SubscriptionSuccessModal = ({ isOpen, onRequestClose }) => {
  const navigate = useNavigate();

  const handleRedirect = () => {
    navigate("/discovery");
    onRequestClose();
  };

  return (
    <Modal
      className="upgrade-prompt"
      isOpen={isOpen}
      onRequestClose={handleRedirect}
      contentLabel="Subscription Successful"
    >
      <h2>Subscription Successful!</h2>
      <p>
        Welcome to Flintt Premium. You now have access to all premium features.
      </p>
      <div className="actions">
        <button onClick={handleRedirect}>Go to Discovery</button>
      </div>
    </Modal>
  );
};

export default SubscriptionSuccessModal;
